var $refreshList;
var $refreshCart;
// add all the elements inside modal which you want to make focusable
// const  focusableElements =
//     'h3, button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
// const modal = document.querySelector('#go-cart-modal'); // select the modal by it's id

// const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
// const focusableContent = modal.querySelectorAll(focusableElements);
// const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

// document.addEventListener('keydown', function(e) {
//   let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

//   if (!isTabPressed) {
//     return;
//   }

//   if (e.shiftKey) { // if shift key pressed for shift + tab combination
//     if (document.activeElement === firstFocusableElement) {
//       lastFocusableElement.focus(); // add focus for the last focusable element
//       e.preventDefault();
//     }
//   } else { // if tab key is pressed
//     if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
//       firstFocusableElement.focus(); // add focus for the first focusable element
//       e.preventDefault();
//     }
//   }
// });

// PLP cursor change on hover position Logic
// window.addEventListener("load", init);
 
// function init() {
//   const img = document.querySelector(".main-collection_product-item-image");
//   const {width} = img.getBoundingClientRect();
//   const halfImgWidth = width / 2;
 
//   img.addEventListener("mousemove", function(e) {
//     const xPos = e.pageX - img.offsetLeft;
//     this.classList.remove("cursor-prev", "cursor-next");
//     if (xPos > halfImgWidth) {
//       this.classList.add("cursor-next");
//     } else {
//       this.classList.add("cursor-prev");
//     }
//   });
// }

// Hide Desktop PDP sectionn on mobile

$(document).ready(function() {
   $('.disabled').click(false);

  // Header Collection Image to show on link hover logic
  $('.header__child-link').each(function(index) {
      $(this).hover(function() {
        UIkit.slideshow('#header__child-link-collection-images').show(index);
      });
  });
  
  // quantity select control
  // $('.quantity-button-plus').on('click', function(){
  //   var currentVal = Number($('#sunny-product_quantity-select-input').val());
  //   $('#sunny-product_quantity-select-input').val(currentVal + 1);  
  // });
  
  // $('.quantity-button-minus').on('click', function(){
  //   var currentVal = Number($('#sunny-product_quantity-select-input').val());
    
  //   if( currentVal > 1){
  //     $('#sunny-product_quantity-select-input').val(currentVal - 1);
  //   } 
  // });
});

